import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root'
})
export class DiscordService {
  private webhookUrl = 'https://discord.com/api/webhooks/1329079027113263144/NWKjF1Gq7F-mAHxMoEfygvJjoK6RSAbWMDDTzAQK4IrfgrOgHQdPn8xmHGvEfYXy4Ae9'
  private fincartWebhookUrl = environment.discordFincartWebhookUrl

  constructor(private http: HttpClient) {}

  sendMessage(content: string, botname: string, isFincart: boolean = false) {
    const url = isFincart ? this.fincartWebhookUrl : this.webhookUrl
    const body = {
      content: content,
      username: botname
    }
    return this.http.post(url, body)
  }

  sendEmbed(embed: object, botname: string, isFincart: boolean = false) {
    const url = isFincart ? this.fincartWebhookUrl : this.webhookUrl
    const body = {
      username: botname,
      embeds: [embed]
    }
    return this.http.post(url, body)
  }
}
